import { GateDefinition, GateRuntimeFeatures } from "modules/gate/types/gate";

const readOverride = (page: GateDefinition, key: keyof GateRuntimeFeatures) => {
    const runtime = page.meta?.runtime;
    if (!runtime || typeof runtime !== "object") return undefined;

    const features = (runtime as Record<string, unknown>).features;
    if (!features || typeof features !== "object") return undefined;

    const value = (features as Record<string, unknown>)[key];
    return typeof value === "boolean" ? value : undefined;
};

const runtimeSource = (page: GateDefinition) => [
    page.head,
    page.template,
    page.script,
    page.style,
    JSON.stringify(page.components || {}),
    ...(page.widgets || []).flatMap((widget) => [
        widget.code,
        widget.template,
        widget.script,
        widget.style,
    ]),
].filter(Boolean).join("\n");

export const resolveGateRuntimeFeatures = (page: GateDefinition): GateRuntimeFeatures => {
    const source = runtimeSource(page);
    const formRuntimeDetected = (page.widgets || []).some((widget) => widget.code === "sp_form_viewer")
        || /<prm-|Gate\.form|__prm(?:CreateFormRuntimeComponent|Components|RegisterFormComponents)/i.test(source);
    const currencyDetected = formRuntimeDetected || /Gate\.currency|prm-currency/i.test(source);
    const translationsDetected = Boolean(page.meta?.i18n)
        || /Gate\.i18n|\$t\s*\(/.test(source);
    const tailwindJitDetected = /cdn\.tailwindcss\.com/i.test(page.head || "");

    return {
        formRuntime: readOverride(page, "formRuntime") ?? formRuntimeDetected,
        currency: readOverride(page, "currency") ?? currencyDetected,
        translations: readOverride(page, "translations") ?? translationsDetected,
        tailwindJit: readOverride(page, "tailwindJit") ?? tailwindJitDetected,
    };
};
